// extracted by mini-css-extract-plugin
export default {"container":"StationCardLoader_container__WVnh4","imgSpin":"StationCardLoader_imgSpin__gOV9O"};